import { makeStyles } from 'tss-react/mui';

const useStylesIconBlockError: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  iconBlockError: {
    position: 'relative',
    color: theme.palette.error.main,
  },
}));

export default useStylesIconBlockError;
